(function() {
	'use strict';

	angular.module('setupApp').controller('LibertyRoleAgController',
			LibertyRoleAgController);

	LibertyRoleAgController.$inject = [ '$scope','$state','$stateParams','$base64','$window', 'LibertyRoleAgService','Upload', '$http', '$log',
			'AlertService', 'authExpiredInterceptor','$uibModal'];

	function LibertyRoleAgController($scope,$state,$stateParams,$base64,$window, LibertyRoleAgService,Upload, $http, $log,AlertService,
			authExpiredInterceptor,$uibModal) {
		var libertyRoleCtr = this;
		var param = $stateParams;
//		libertyRoleCtr.loadAgent = function(){
//			LibertyRoleAgService.query({
//				uri : 'get-all-agent'
//			}).$promise.then(function(result) {
//				libertyRoleCtr.lstAgent=result;
//			});
//		}
//		LibertyRoleAgService.query({
//			uri : 'get-all-agent'
//		}).$promise.then(function(result) {
//			libertyRoleCtr.lstAgent=result;
//		});
		
		
		libertyRoleCtr.assign = function() {
			var data = [];
				if (libertyRoleCtr.attachmentAssign != null || libertyRoleCtr.attachmentAssign != undefined || libertyRoleCtr.agentCodeAssign != null || libertyRoleCtr.agentCodeAssign != undefined) {
					$scope.loading=true;
					if(libertyRoleCtr.attachmentAssign != null || libertyRoleCtr.attachmentAssign != undefined){
						data['file'] = libertyRoleCtr.attachmentAssign;
					}
					if(libertyRoleCtr.agentCodeAssign != null || libertyRoleCtr.agentCodeAssign != undefined){
						data['agentCode'] = libertyRoleCtr.agentCodeAssign;
					}
					Upload.upload(
						{
							url : GLOBAL_URL
									+ 'api/ga/setup/libertyroleag/doUploadFileInsert?access_token='
									+ authExpiredInterceptor.getToken(),
							data : data
						}).then(
						function(resp) {
							$scope.loading=false;
							$scope.addAlert('Gán quyền thành công','success');
							LibertyRoleAgService.download({uri:'result-upload'},resp.data);
						},
						function(resp) {
							$scope.loading=false;
						},
						function(evt) {
							$scope.loading=false;
							var progressPercentage = parseInt(100.0
									* evt.loaded / evt.total);
						});
				}else{
					$scope.addAlert('Vui lòng chọn ít nhất 1 văn phòng hoặc upload 1 file chứa mã office ga code','warning');
				}
		} 
		
		libertyRoleCtr.remove = function() {
			var data = [];
				if (libertyRoleCtr.attachmentRemove != null || libertyRoleCtr.attachmentRemove != undefined || libertyRoleCtr.agentCodeRemove != null || libertyRoleCtr.agentCodeRemove != undefined) {
					$scope.loading=true;
					if(libertyRoleCtr.attachmentRemove != null || libertyRoleCtr.attachmentRemove != undefined){
						data['file'] = libertyRoleCtr.attachmentRemove;
					}
					if(libertyRoleCtr.agentCodeRemove != null || libertyRoleCtr.agentCodeRemove != undefined){
						data['agentCode'] = libertyRoleCtr.agentCodeRemove;
					}
					Upload.upload(
						{
							url : GLOBAL_URL
									+ 'api/ga/setup/libertyroleag/doUploadFileRemove?access_token='
									+ authExpiredInterceptor.getToken(),
							data : data
						}).then(
						function(resp) {
							$scope.loading=false;
							$scope.addAlert('Xóa quyền thành công','success');
							LibertyRoleAgService.download({uri:'result-remove'},resp.data);
						},
						function(resp) {
							$scope.loading=false;
						},
						function(evt) {
							$scope.loading=false;
							var progressPercentage = parseInt(100.0
									* evt.loaded / evt.total);
						});
				}else{
					$scope.addAlert('Vui lòng chọn ít nhất 1 agent hoặc upload 1 file chứa mã agent code','warning');
				}
		} 

	}


})();
